/** §4.3: HH:MM:SS:FF, FF = frameIndex % round(fps); `;` hint for 29.97/59.94 (no drop-frame math in v1). */
export function frameIndexFromMs(ms: number, fps: number): number {
  return Math.round((ms * fps) / 1000);
}
export function frameIndexFromSeconds(sec: number, fps: number): number {
  return Math.round(sec * fps);
}
export function msFromFrame(frame: number, fps: number): number {
  return ((frame + 0.5) / fps) * 1000;
}
export function timecode(frameIndex: number, fps: number): string {
  const r = Math.round(fps);
  const totalSec = Math.floor(frameIndex / r);
  const ff = frameIndex % r;
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  const sep = Math.abs(fps - 29.97) < 0.01 || Math.abs(fps - 59.94) < 0.01 ? ';' : ':';
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(h)}:${p(m)}:${p(s)}${sep}${p(ff)}`;
}
export function msToClock(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  const m = Math.floor(s / 60);
  const h = Math.floor(m / 60);
  const p = (n: number) => String(n).padStart(2, '0');
  return h ? `${h}:${p(m % 60)}:${p(s % 60)}` : `${m}:${p(s % 60)}`;
}
